import { PlayerRef } from '@remotion/player';
import { useMemo } from 'react';
import { AbsoluteFill } from 'remotion';
import { byDefaultKeepAspectRatioMap } from '../utils/aspect-ratio';
import { useDrawingTool } from './use-drawing-tool';

const SHAPE_DURATION_IN_FRAMES = 100;

export const SolidDrawingTool: React.FC<{
  playerRef: React.RefObject<PlayerRef | null>;
}> = ({ playerRef }) => {
  const createItemConfig = useMemo(
    () => () => ({
      type: 'solid' as const,
      color: '#ffffff',
      durationInFrames: SHAPE_DURATION_IN_FRAMES,
      opacity: 1,
      borderRadius: 0,
      rotation: 0,
      keepAspectRatio: byDefaultKeepAspectRatioMap.solid,
      fadeInDurationInSeconds: 0,
      fadeOutDurationInSeconds: 0,
    }),
    [],
  );

  useDrawingTool({ playerRef, createItemConfig });

  return <AbsoluteFill style={{ zIndex: 1001 }} />;
};
